const compareVersions = (a, b) => {
    const versionA = a || '';
    const versionB = b || '';

    const pa = versionA.split('.').map(Number);
    const pb = versionB.split('.').map(Number);
    const len = Math.max(pa.length, pb.length);

    for (let i = 0; i < len; i++) {
        const na = pa[i] || 0;
        const nb = pb[i] || 0;

        if (na > nb) return 1;
        if (na < nb) return -1;
    }
    return 0;
};

const versionInRange = (version, expression) => {
    let op = '==';
    let target = expression;

    if (expression.startsWith('<=')) {
        op = '<=';
        target = expression.slice(2);
    } else if (expression.startsWith('>=')) {
        op = '>=';
        target = expression.slice(2);
    } else if (expression.startsWith('<')) {
        op = '<';
        target = expression.slice(1);
    } else if (expression.startsWith('>')) {
        op = '>';
        target = expression.slice(1);
    }

    const cmp = compareVersions(version, target);

    switch (op) {
        case '<=':
            return cmp <= 0;
        case '<':
            return cmp < 0;
        case '>=':
            return cmp >= 0;
        case '>':
            return cmp > 0;
        case '==':
            return cmp === 0;
        default:
            return false;
    }
};

const getBestMatchVersion = (rules) => {
    return rules
        .toSorted((a, b) => {
            // First, check if the rules are exact matches or range-based
            const isExactA = !a.versionRange.match(/^[<>]/);
            const isExactB = !b.versionRange.match(/^[<>]/);

            // Exact matches take precedence
            if (isExactA && !isExactB) return 1;
            if (!isExactA && isExactB) return -1;

            // If both are of the same type, compare by version
            const va = a.versionRange.replace(/^[<>=]*/, '');
            const vb = b.versionRange.replace(/^[<>=]*/, '');

            return compareVersions(va, vb);
        })
        .pop();
};

export default {compareVersions, versionInRange, getBestMatchVersion};
